import React from 'react';
import { Route } from 'react-router-dom';
import { CUSTOMERS, CREATE_CUSTOMER } from './paths';
import Customers from 'modules/Customers/Customers';
import CreateCustomer from 'modules/CreateCustomer/CreateCustomer';
function CustomersRoutes() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: CUSTOMERS
  }, /*#__PURE__*/React.createElement(Customers, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: CREATE_CUSTOMER
  }, /*#__PURE__*/React.createElement(CreateCustomer, null)));
}
export default CustomersRoutes;